import { isArray } from 'util';
import { OperationSummary } from '../operation-summary';

export class OperationSummaryBuilder {
  static fromJson(json) {
    return (json)
      ? new OperationSummary(
        json.daily,
        json.incidence,
        json.oee,
        json.realTimePerPiece,
        json.medianTimePerPiece,
        json.schedulerTaskHash,
        json.schedulerTaskStatus,
        json.schedulerTaskStartDate,
        json.schedulerTaskEndDate,
        json.week,
        json.schedulerTaskTimes,
        json.schedulerTaskTimesTrend,
        json.model
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(OperationSummaryBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operation-summary.builder.ts